<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <div class="form-body col-md-8 col-12">
      <v-row class="form-item-section decleration-form-section">
        <v-row class="decleration-row p-b-15" v-slimscroll>
          <v-col cols="12" sm="12" md="12" class="heading">
            <h3>Declaration</h3>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="decleration-input-wrapper">
            All material facts must be disclosed to Underwriters whether or not
            the subject of a specific question above. A material fact is one
            which a prudent Underwriter would regard as likely to influence the
            acceptance or assessment of the proposal. Non-disclosure or
            misrepresentation of a material fact may result in the insurance
            being void. If you are in any doubt whether facts would be
            considered material, you should disclose them. Should something
            become known or a matter arise during the currency of your insurance
            which could be considered to be a material fact this should also be
            advised to Underwriters immediately.
          </v-col>
        </v-row>

        <v-col
          cols="12"
          sm="12"
          md="12"
          class="decleration-input-wrapper checkbox-container"
        >
          <v-checkbox v-model="$store.state.isAgreed">
            <template v-slot:label>
              <div
                class="checkbox-text"
                @click.stop
                :lang="getLang">
                I declare that the particulars and answers are correct and complete in every respect to my knowledge and belief.
                I agree that this proposal and declaration shall form the basis of the contract of insurance between me and the Underwriters if a policy is issued.
              </div>
            </template>
          </v-checkbox>
          <div class="margin-top-small">
            <v-checkbox v-model="$store.state.isAgreedConfirm">
              <template v-slot:label>
                <div
                    class="checkbox-text"
                    @click.stop
                    :lang="getLang">
                  I confirm that I have read Marsh’s <a @click.stop="menuClicked('PICS')" class="privacy_link" >Personal Information Collection Statement</a> and agree to Marsh’s collection and use of my personal data in accordance with the <a @click.stop="menuClicked('privacy-policy')" class="privacy_link" >Privacy Notice</a>.
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-col cols="12" class="button-container col-md-8">
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="goMarshHome"
      >
        Cancel Application
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        :disabled="!$store.state.isAgreed || !$store.state.isAgreedConfirm"
        @click="validateAndGoNext"
      >
        Continue
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import PremiumApi from "@/plugins/axios";

export default {
  data() {
    return {
      valid: false
    };
  },
  methods: {
    validateAndGoNext: function() {
      if (this.$refs.form.validate()) {
        this.$store.state.formPageNumber = 1;
      } else {
        console.log("Invalid");
      }
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/Declaration";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
    goHome: function() {
      this.$store.state.formPageNumber=0;
    },
    goMarshHome: function() {
      console.log('in')
      const locale = this.$store.state.country
      const prodURL = {
        hk: "https://www.marsh.com/hk/en/industries/marine/products/yachtcover.html",
        sg: "https://www.marsh.com/sg/industries/marine/products/yachtcover.html",
        th: "https://www.marsh.com/th/en/industries/marine/products/yachtcover.html"
      };
      // const nonProdURL =  {
      //   hk: "https://author.www.marshinc.net/content/marsh/blueprints1/as/en/industries/marine/yachtcover.html",
      //   sg: "https://author.www.marshinc.net/content/marsh/asia/sg/en_sg/industries/marine/yachtcover.html?wcmmode=disabled"
      // };
      window.location.href = prodURL[locale];
      // if(location.hostname === "yachtcover.map.marsh.com") {
      //   window.location.href = prodURL[locale];
      // } else {
      //   window.location.href = nonProdURL[locale];
      // }
    },
    menuClicked: function (p) {
      switch (p) {
        case 'PICS':
          this.$store.state.formPageNumber = -1;
          return;
        case 'privacy-policy':
          this.$store.state.formPageNumber = -2;
          return;
        case 'terms-of-use':
          this.$store.state.formPageNumber = -3;
          return;
        default:
          this.$store.state.formPageNumber = 0;
          return;
      }

    }
  },
  mounted: function() {
    const hasIpAddress = !this.$store.state.accessData.ipAddress ? false : true;
    if (hasIpAddress) {
      this.trackPage();
    } else {
      const _this = this;
      PremiumApi.getIpAddress(function(data) {
        _this.$store.dispatch("saveIpAddress", data);
        _this.trackPage();
      });
    }
  },
  computed: {
    getLang() {
      //return this.$store.state.country === "hk" ? "hk" : "sg";
      if(this.$store.state.country === "hk"){
        return "hk";
      }else if(this.$store.state.country === "th"){
        return "th";
      }else {
        return "sg";
      }
    },
  },
};
</script>
